import React from "react";
import "./teamFilter.css";
import { withRouter } from 'react-router-dom'

class TeamFilter extends React.Component {
  state = {
    selectedTeam: null
  };


  componentDidMount() {
    //console.log("MOUNT setting selected team id to ", this.props.teamId);
    this.setState({ selectedTeam: this.props.teamId });
  }

  teamChanged(teamId) {
    // console.log("Team changed team id to ",teamId);
    this.props.changed(this.props.searchValue, teamId, this.props.status);
    const searchValue = this.props.searchValue ? "/" + this.props.searchValue : "";
    const statusId = this.props.status ? this.props.status : "any";

    this.props.history.push(this.props.page + teamId + "/" + statusId + searchValue);

    this.setState({ selectedTeam: teamId });
  }



  render() {
    // console.log("selected team id IS=", this.state.selectedTeam);
    const isSelected = teamId => (this.state.selectedTeam == teamId ? "selected" : null);

    return this.props.forMemberActivities
      ? (
        <div className="team-filter-wrapper">
          <button value="0" className={isSelected(0)} onClick={e => this.teamChanged(e.target.value)}>
            Børneholdet
        </button>
          <button value="1" className={isSelected(1)} onClick={e => this.teamChanged(e.target.value)}>
            Ung/voksen
        </button>
          <button value="2" className={isSelected(2)} onClick={e => this.teamChanged(e.target.value)}>
            Ichiban
        </button>         
          <button value="-100" className={isSelected(-100)} onClick={e => this.teamChanged(e.target.value)}>
            Alle
        </button>
        </div>
      )
      : (
        <div className="team-filter-wrapper">
          <button value="0" className={isSelected(0)} onClick={e => this.teamChanged(e.target.value)}>
            Børneholdet
        </button>
          <button value="1" className={isSelected(1)} onClick={e => this.teamChanged(e.target.value)}>
            Ung/voksen
        </button>
          <button value="2" className={isSelected(2)} onClick={e => this.teamChanged(e.target.value)}>
            Ichiban
        </button>
          <button value="3" className={isSelected(3)} onClick={e => this.teamChanged(e.target.value)}>
            Passiv
        </button>
          <button value="99" className={isSelected(99)} onClick={e => this.teamChanged(e.target.value)}>
            Udmeldt
        </button>
          <button value="-1" className={isSelected(-1)} onClick={e => this.teamChanged(e.target.value)}>
            Alle
        </button>
        </div>
      )
  }
}

export default withRouter(TeamFilter);
